module.exports = __webpack_public_path__ + "static/KalbReportLogo-0b2af26b44e9bd0f27b6231bb1deed8f.png";